import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import Badge from "../Badge";
import Box from "../Box";
import Group from "../Group";
import { FormContext } from "./";
import { NegativeNotice } from "../Notice";
import { Text } from "../Text";
export var FormBlockContext = React.createContext({});

var FormBlock = function FormBlock(props) {
  var children = props.children,
      className = props.className,
      description = props.description,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? true : _props$divider,
      error = props.error,
      rowDividers = props.rowDividers,
      title = props.title,
      tag = props.tag,
      remaining = _objectWithoutProperties(props, ["children", "className", "description", "divider", "error", "rowDividers", "title", "tag"]);

  var classes = classNames('FormBlock', className);
  var hasCopy = title || description;

  var getDivider = function getDivider() {
    return divider ? {
      color: 'light',
      side: 'bottom',
      width: 1
    } : null;
  };

  var value = React.useMemo(function () {
    return {
      rowDividers: rowDividers
    };
  }, [rowDividers]);
  return /*#__PURE__*/React.createElement(FormContext.Consumer, null, function (_ref) {
    var layout = _ref.layout,
        size = _ref.size;
    var textLineHeightValue = size === 'jumbo' ? 24 : 20;
    var textSizeValue = size === 'jumbo' ? 16 : 14;
    return /*#__PURE__*/React.createElement(FormBlockContext.Provider, {
      value: value
    }, /*#__PURE__*/React.createElement("fieldset", _extends({}, remaining, {
      className: classes
    }), /*#__PURE__*/React.createElement(Box, {
      divider: getDivider(),
      padding: rowDividers ? 0 : {
        vertical: 8
      }
    }, hasCopy && /*#__PURE__*/React.createElement(Box, {
      className: "FormBlock-header",
      padding: {
        bottom: 20,
        horizontal: 20,
        top: rowDividers ? 20 : 12
      }
    }, title && /*#__PURE__*/React.createElement(Text, {
      color: "dark",
      display: "block",
      lineHeight: textLineHeightValue,
      size: textSizeValue,
      weight: "medium"
    }, /*#__PURE__*/React.createElement(Group, {
      direction: "horizontal",
      spacing: 8,
      alignItems: "center"
    }, title, tag && /*#__PURE__*/React.createElement(Badge, {
      variant: "tag",
      label: tag
    }))), description && /*#__PURE__*/React.createElement(Text, {
      lineHeight: textLineHeightValue,
      size: textSizeValue
    }, description)), error && /*#__PURE__*/React.createElement(NegativeNotice, {
      role: "alert",
      title: error
    }), /*#__PURE__*/React.createElement(Box, {
      divider: rowDividers && hasCopy ? {
        color: 'light',
        side: 'top',
        width: 1
      } : null
    }, children))));
  });
};

export default FormBlock;